<template>
  <div
    class="cg-bar-track d-flex overflow-hidden rounded-1"
    :style="{ height: `${height}px` }"
  >
    <div
      v-for="(segment, index) in segments"
      :key="index"
      :style="{ width: segment.pct, background: FILL[segment.fill] }"
    />
  </div>
</template>

<script setup lang="ts">
import type { Fill } from "@/compliance_groups/fixture/complianceGroupsTypes";
import { FILL } from "@/compliance_groups/fixture/fills";

withDefaults(
  defineProps<{ segments: { fill: Fill; pct: string }[]; height?: number }>(),
  { height: 26 }
);
</script>

<style scoped lang="scss">
.cg-bar-track {
  background: var(--phoenix-gray-100);
}
</style>
